import { Point } from "./Point";

/**
 * Represents a line part in 1D space.
 */
export interface LinePart {
  start: number;
  end: number;
}

export interface Size {
  width: number;
  height: number;
}

export class Rect implements Size {
  /**
   * @param x x-position of the upper left corner of the rectangle.
   * @param y y-potition of the upper left corner of the rectangle.
   */
  constructor(
    public x: number,
    public y: number,
    public width: number,
    public height: number,
  ) {}

  get center(): Point {
    return new Point(this.x + this.width / 2, this.y + this.height / 2);
  }
}
